(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sf-nutrition"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-nutri-tabs')) {
    class SfNutriTabs extends HTMLElement {
      connectedCallback() {
        this.classList.add('is-ready');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('keydown', (event) => this.onKey(event, index), { signal });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onKey(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute("aria-controls"));
          if (panel) panel.toggleAttribute('data-hidden', !selected);
        });
      }
    }
    customElements.define('sf-nutri-tabs', SfNutriTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sf-pack-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-pack-selector')) {
    class SfPackSelector extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        document.documentElement.classList.add('sf-pack-ready');
        this.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onClick(event) {
        const card = event.target instanceof Element ? event.target.closest('.sf-pack__card') : null;
        if (!card || card.disabled) return;
        const variantId = card.dataset.variantId;
        const picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
        const input = picker?.querySelector(`input[data-variant-id="${variantId}"]`);
        if (!input) return;
        for (const other of this.querySelectorAll('.sf-pack__card')) {
          other.setAttribute('aria-pressed', String(other === card));
        }
        if (!input.checked) input.click();
      }
    }
    customElements.define('sf-pack-selector', SfPackSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sf-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-upsell')) {
    class SfUpsell extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('submit', (event) => this.onSubmit(event), { signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      onClick(event) {
        const arrow = event.target instanceof Element ? event.target.closest('.sf-upsell__arrow') : null;
        if (!arrow) return;
        const row = this.querySelector('.sf-upsell__row');
        if (!row) return;
        row.scrollBy({ left: Number(arrow.dataset.dir) * row.clientWidth, behavior: 'smooth' });
      }

      async onSubmit(event) {
        const form = event.target;
        const actions = window.Shopify?.actions;
        if (!(form instanceof HTMLFormElement) || !actions?.updateCart) return;
        event.preventDefault();
        const button = form.querySelector('button');
        const label = form.querySelector('.sf-upsell__add-text');
        const variantId = form.querySelector('input[name="id"]')?.value;
        if (!variantId || !button) return;
        button.disabled = true;
        try {
          const result = await actions.updateCart(
            { lines: [{ merchandiseId: variantId, quantity: 1 }] },
            { event: { context: 'product' } }
          );
          if (result?.userErrors?.length) throw new Error(result.userErrors[0].message);
          if (label) label.textContent = 'Added';
          await actions.openCart?.();
        } catch (error) {
          form.submit();
          return;
        } finally {
          button.disabled = false;
        }
        window.setTimeout(() => {
          if (label) label.textContent = 'Add +';
        }, 2500);
      }
    }
    customElements.define('sf-upsell', SfUpsell);
  }
  } catch(e) { console.error(e); }
})();

})();
